/**
 * @author Aavesh Jilani
 * @created 2025-12-25
 * @description common chip model
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonChipData } from './common-chip.component.model';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'wm-common-chip',
  standalone: false,
  templateUrl: './common-chip.component.html',
  styleUrls: ['./common-chip.component.scss']
})
export class CommonChipComponent {

  private _data: CommonChipData = {
    label: '',
    color: 'default',
    removable: false,
    disabled: false,
    id: '',
  };

  @Input()
  set data(value: CommonChipData) {
    this._data = { ...this._data, ...value };
  }

  get data(): CommonChipData {
    return this._data;
  }

  get statusClass(): string {
  switch (this.data.color) {
    case 'success':
      return 'chip-success';
    case 'error':
      return 'chip-error';
    case 'warning':
      return 'chip-warning';
    default:
      return '';
  }
}


  @Output() onClick = new EventEmitter<void>();
  @Output() onDelete = new EventEmitter<void>();

}
